module.exports = __webpack_public_path__ + "img/40_38_049_460.6aa7f508.jpg";